import { getAllCloseReasons } from "@coworker/apprestructured/src/task-management/services/close-reasons.service";
import { useQuery } from "@tanstack/react-query";

export function useAllCloseReasons({
  enabled = true,
}: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["close-reasons"],
    queryFn: getAllCloseReasons,
    staleTime: Infinity,
    enabled,
  });
}
